import { HttpErrorResponse } from '@angular/common/http';

export function apiErrorCode(error: unknown): string | null {
  const response = error as HttpErrorResponse | null;
  const payload = response?.error as Record<string, unknown> | null | undefined;
  return typeof payload?.['code'] === 'string'
    ? payload['code']
    : typeof payload?.['detail'] === 'string'
      ? payload['detail']
      : null;
}

export function apiErrorMessage(error: unknown, fallback: string): string {
  const response = error as HttpErrorResponse | null;
  const code = apiErrorCode(error);
  if (code) return code;
  if (response?.status === 401) return 'Your session has expired. Please sign in again.';
  if (response?.status === 403) return 'You do not have permission for this action.';
  if (response?.status === 404) return 'The requested resource was not found.';
  if (response && response.status >= 500) return 'The API is temporarily unavailable.';
  return fallback;
}

export function firstValidationError(error: unknown): string | null {
  const response = error as HttpErrorResponse | null;
  const payload = response?.error as Record<string, unknown> | null | undefined;
  if (!payload) return null;
  for (const value of Object.values(payload)) {
    if (typeof value === 'string') return value;
    if (Array.isArray(value) && typeof value[0] === 'string') return value[0];
    if (value && typeof value === 'object') {
      const nested = firstValidationError({ error: value });
      if (nested) return nested;
    }
  }
  return null;
}
